import { render, staticRenderFns } from "./SearchNavCompanyIds.vue?vue&type=template&id=24b639a9&scoped=true&"
import script from "./SearchNavCompanyIds.vue?vue&type=script&lang=js&"
export * from "./SearchNavCompanyIds.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavCompanyIds.vue?vue&type=style&index=0&id=24b639a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b639a9",
  null
  
)

export default component.exports